import { Tooltip } from '@alphonsocode/kallos';
import React, { ReactNode } from 'react';

type CustomTooltipProps = {
  overlay: string;
  children: ReactNode;
};

const CustomTooltip: React.FC<CustomTooltipProps> = ({ overlay, children }) => {
  return (
    <Tooltip
      overlay={overlay}
      openDelay={0}
      closeDelay={0}
      arrow={false}
      style={{
        maxWidth: '300px',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        marginTop: 5,
      }}
    >
      {children}
    </Tooltip>
  );
};

export default CustomTooltip;
